import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { App as AntdApp, message } from "antd";
import { AppRoutes } from './routes'
import { Sidebar } from './components/layout/sidebar';
import { PageWrapper } from './components/layout/page-wrapper';
import { AuthWrapper } from './components/layout/auth-wrapper';
import { AHUPage } from './pages/ahu/index';
import { AutopilotPage } from './pages/autopilot';
import { AutopilotProvider } from './contexts/autopilot-context';
import { SettingsPage } from './pages/settings';
import { CreateAutomation } from './pages/autopilot/create';
import { AutomationDetail } from './pages/autopilot/automation-detail';
import { ConfigProvider } from 'antd';
import { antdTheme, COLOR } from './styles/constants';
import { UserProvider } from './auth/UserProvider';
import { AuthProvider } from './auth';
import { ZoneProvider } from './auth/zoneProvider';
import { EnumMappingsProvider } from './contexts/enum-mappings-context';
import { NotificationProvider } from './contexts/notification-context';
import { ActionNotifications } from './components/ui/action-notification';
import { ActionNotificationListener } from './components/action-notification-listener';

function App() {
  const [messageApi, contextHolder] = message.useMessage()
  return (
    <AutopilotProvider>
      <ConfigProvider
        theme={antdTheme}
      >
        <AntdApp message={messageApi}>
          {contextHolder}
          <AuthProvider>
            {/* <UserProvider> */}
            <ZoneProvider>
              <EnumMappingsProvider>
                <NotificationProvider autoRemoveTime={120000}> {/* 2 minutes */}
                  <AppRoutes />
                  <ActionNotifications />
                  <ActionNotificationListener />
                </NotificationProvider>
              </EnumMappingsProvider>
            </ZoneProvider>
            {/* </UserProvider> */}
          </AuthProvider>
        </AntdApp>
      </ConfigProvider>
    </AutopilotProvider>
  );
}

export default App;